import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import Popover from 'ui-library/floating-ui/Popover';
import {ellipsize} from 'util/NameUtil';

const MAX_BASES_SHOWN = 8;

function renderPopoverContent(bases: string): JSX.Element {
  return <div className={css(styles.popoverContent)}>{bases}</div>;
}

function getBasesCellText(bases: string): string {
  const ellipsizedBases = ellipsize(bases, MAX_BASES_SHOWN + 3);
  if (bases.length > MAX_BASES_SHOWN) {
    return `${ellipsizedBases} ${bases.length} bp`;
  }
  return ellipsizedBases;
}

interface BulkAssemblyPrimerBasesProps {
  typedValue: TypedValue;
}

export default function BulkAssemblyPrimerBases({
  typedValue,
}: BulkAssemblyPrimerBasesProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.STRING) {
    return (
      <Popover renderContent={() => renderPopoverContent(typedValue.rawValue)}>
        <div>{getBasesCellText(typedValue.rawValue)}</div>
      </Popover>
    );
  }
  return null;
}

const styles = StyleSheet.create({
  popoverContent: {
    maxWidth: '200px',
    wordWrap: 'break-word',
  },
});
